import { render, staticRenderFns } from "./salesProjectShow.vue?vue&type=template&id=2e1874de&scoped=true&"
import script from "./salesProjectShow.vue?vue&type=script&lang=js&"
export * from "./salesProjectShow.vue?vue&type=script&lang=js&"
import style0 from "./salesProjectShow.vue?vue&type=style&index=0&id=2e1874de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1874de",
  null
  
)

export default component.exports